/**
 * Chart state persistence for natal chart tool.
 * Uses localStorage so the chart survives navigation, refresh, and is available in new tabs (e.g. print).
 */

export const NATAL_CHART_STORAGE_KEY = 'natalChartData';
export const LEGACY_REPORT_STORAGE_KEY = 'chartReportData';

/**
 * @param {{ chartResult: object, meta: object }} data
 */
export function saveNatalChart(data) {
  try {
    localStorage.setItem(NATAL_CHART_STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Could not save chart to sessionStorage', e);
    }
  }
}

/**
 * @returns {{ chartResult: object, meta: object } | null}
 */
export function loadNatalChart() {
  try {
    const stored = localStorage.getItem(NATAL_CHART_STORAGE_KEY)
      || sessionStorage.getItem(NATAL_CHART_STORAGE_KEY)
      || sessionStorage.getItem(LEGACY_REPORT_STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (!parsed?.chartResult) return null;
    return parsed;
  } catch {
    return null;
  }
}
